import { MessageCircle, Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export default function FloatingCTA() {
  const waMessage = encodeURIComponent(
    "Hallo Care for Elektra, ik heb een vraag over jullie diensten."
  );
  return (
    <div
      data-testid="floating-cta"
      className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 flex flex-col gap-3 items-end"
    >
      <a
        href={`tel:${SITE.phoneIntl}`}
        data-testid="floating-call-btn"
        aria-label="Bel Care for Elektra"
        className="w-13 h-13 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-[#0A1128] text-white shadow-2xl hover:bg-[#FF6B00] hover:scale-110 transition-transform"
      >
        <Phone className="w-5 h-5 md:w-6 md:h-6" />
      </a>
      <a
        href={`https://wa.me/${SITE.whatsapp}?text=${waMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="WhatsApp Care for Elektra"
        className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform"
      >
        <MessageCircle className="w-6 h-6 md:w-7 md:h-7" />
      </a>
    </div>
  );
}
